import { SDK } from './helpers/sdk';
import { SDKFactory } from './helpers/sdk.factory';
import type { FirestoreClientData } from './interfaces';
import type { CheckoutSession, Order } from '@sda/interfaces/order';

/**
 * SDK Class to interact with the Orders collection
 */
export class Orders extends SDK<Order> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient);

    this.collection = this.fsh.Schema.PrivateOrders;
  }

  /**
   * Returns a FirestoreBaseClass instance for the PrivateCheckoutSessions collection
   * @return {FirestoreBaseClass}
   */
  CheckoutSessions(): SDK<CheckoutSession> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<CheckoutSession>(clientData, Schema.PrivateCheckoutSessions);
  }
}
